//
//
//
//
export default {
  name: 'authredirect',
  created: function created() {
    window.close();
    var params = this.$route.query;
    var state = params.state;
    var code = params.code;
    window.opener.location.href = "".concat(window.location.origin, "/#/login?state=").concat(state, "&code=").concat(code);
  }
};